import Skeleton from '@material-ui/lab/Skeleton';
import React from 'react';
import { Card, Grid, Paper } from '@material-ui/core';
import './dashboardSkeleton.scss';

const DashboardSkeleton = ({
                             kpiCount = 4,
                             sideCardCount = 2,
                             showBigChart = true,
                             showTable = true,
                           }) => {
  return (
    <Card className="dashboard-skeleton">
      <Grid container spacing={3}>

        {/* Header Title */}
        <Grid item xs={12}>
          <Skeleton variant="text" width={250} height={40} className="shimmer" />
        </Grid>


        {/* KPI Cards */}
        {Array.from({ length: kpiCount }).map((_, i) => (
          <Grid item xs={12} md={3} key={i}>
            <Paper className="skeleton-card">
              <Skeleton variant="text" width="60%" height={30} className="shimmer" />
              <Skeleton variant="text" width="40%" height={30} className="shimmer mt-1" />
            </Paper>
          </Grid>
        ))}



        {/* Side Stats */}
        <Grid item xs={12} md={showBigChart ? 4 : 12}>
          {Array.from({ length: sideCardCount }).map((_, i) => (
            <Paper
              key={i}
              className={`skeleton-card small ${i > 0 ? 'mt-2' : ''}`}
            >
              <Skeleton variant="rect" height={150} className="shimmer" />
            </Paper>
          ))}
        </Grid>

        {/* Big Chart */}
        {showBigChart && (
          <Grid item xs={12} md={8}>
            <Paper className="skeleton-card">
              <Skeleton variant="rect" height={320} className="shimmer" />
            </Paper>
          </Grid>
        )}




        {/* Table */}
        {showTable && (
          <Grid item xs={12}>
            <Paper className="skeleton-card">
              <Skeleton variant="rect" height={350} className="shimmer" />
            </Paper>
          </Grid>
        )}
      </Grid>
    </Card>
  );
};

export default DashboardSkeleton;
